// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dappNav_navbar__uwBFL {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 12px;
    background-color: #040404;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .dappNav_navContainer__oFsNn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .dappNav_navLeft__7\\+HuK {
    display: flex;
    align-items: center;
  }
  
  .dappNav_logo__tIcDq {
    height: 40px;
    display: flex;
    align-items: center;
  }

  .dappNav_logo__tIcDq img {
    height: 100%;
    width: auto;
    max-height: 24px;
    object-fit: contain;
  }

  .dappNav_navRight__xSZi0 {
    display: flex;
    align-items: center;
    gap: 24px;
  }
  
  .dappNav_navMenu__Ri3SY {
    display: flex;
    list-style: none;
    gap: 2rem;
    margin: 0;
    padding: 0;
  }
  
  .dappNav_navLink__K41jH {
    text-decoration: none;
    color: #ffffff;
    font-weight: 400;
    transition: color 0.2s ease;
  }
  
  .dappNav_navLink__K41jH:hover {
    color: rgb(255, 255, 255, 0.7);
  }
  
  .dappNav_hamburger__VqtKc {
    display: none;
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    color: #ffffff;
    transition: transform 0.3s ease;
  }
  
  .dappNav_hamburger__VqtKc:hover {
    opacity: 0.7;
  }
  
  .dappNav_hamburger__VqtKc svg {
    transition: transform 0.3s ease;
  }
  
  .dappNav_hamburger__VqtKc:hover svg {
    transform: scale(1.1);
  }
  
  @media (max-width: 900px) {
    .dappNav_navRight__xSZi0 {
      position: relative;
    }
  
    .dappNav_hamburger__VqtKc {
      display: block;
      z-index: 1001;
    }
  
    .dappNav_navMenu__Ri3SY {
      display: none;
      margin: 0;
      padding: 0;
      list-style: none;
    }
  
    .dappNav_mobileNav__R1S84 {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      width: 280px;
      background: #090909;
      padding: 80px 20px 20px;
      transform: translateX(-100%);
      transition: transform 0.3s ease;
      z-index: 1000;
      box-shadow: 4px 0 12px rgba(0, 0, 0, 0.3);
    }
  
    .dappNav_mobileNav__R1S84.dappNav_open__-8Q5k {
      transform: translateX(0);
    }
  
    .dappNav_mobileNav__R1S84.dappNav_open__-8Q5k .dappNav_navMenu__Ri3SY {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
    }
  
    .dappNav_navLink__K41jH {
      display: block;
      padding: 12px 0;
      font-size: 18px;
      color: #ffffff;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
  
    .dappNav_navLink__K41jH:last-child {
      border-bottom: none;
    }
  }
  
  /* Add overlay background when menu is open */
  .dappNav_overlay__yV\\+CY {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
  
  @media (max-width: 900px) {
    .dappNav_overlay__yV\\+CY.dappNav_open__-8Q5k {
      display: block;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/components/dappNav/dappNav.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,cAAc;MACd,aAAa;IACf;;IAEA;MACE,aAAa;MACb,SAAS;MACT,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,MAAM;MACN,OAAO;MACP,SAAS;MACT,YAAY;MACZ,mBAAmB;MACnB,uBAAuB;MACvB,4BAA4B;MAC5B,+BAA+B;MAC/B,aAAa;MACb,yCAAyC;IAC3C;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,cAAc;MACd,eAAe;MACf,eAAe;MACf,cAAc;MACd,iDAAiD;IACnD;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE;MACE,cAAc;IAChB;EACF","sourcesContent":[".navbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 12px;\n    background-color: #040404;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .navContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    max-width: 1600px;\n    margin: 0 auto;\n    padding: 0 20px;\n  }\n  \n  .navLeft {\n    display: flex;\n    align-items: center;\n  }\n  \n  .logo {\n    height: 40px;\n    display: flex;\n    align-items: center;\n  }\n\n  .logo img {\n    height: 100%;\n    width: auto;\n    max-height: 24px;\n    object-fit: contain;\n  }\n\n  .navRight {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n  }\n  \n  .navMenu {\n    display: flex;\n    list-style: none;\n    gap: 2rem;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .navLink {\n    text-decoration: none;\n    color: #ffffff;\n    font-weight: 400;\n    transition: color 0.2s ease;\n  }\n  \n  .navLink:hover {\n    color: rgb(255, 255, 255, 0.7);\n  }\n  \n  .hamburger {\n    display: none;\n    background: none;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    color: #ffffff;\n    transition: transform 0.3s ease;\n  }\n  \n  .hamburger:hover {\n    opacity: 0.7;\n  }\n  \n  .hamburger svg {\n    transition: transform 0.3s ease;\n  }\n  \n  .hamburger:hover svg {\n    transform: scale(1.1);\n  }\n  \n  @media (max-width: 900px) {\n    .navRight {\n      position: relative;\n    }\n  \n    .hamburger {\n      display: block;\n      z-index: 1001;\n    }\n  \n    .navMenu {\n      display: none;\n      margin: 0;\n      padding: 0;\n      list-style: none;\n    }\n  \n    .mobileNav {\n      position: fixed;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      width: 280px;\n      background: #090909;\n      padding: 80px 20px 20px;\n      transform: translateX(-100%);\n      transition: transform 0.3s ease;\n      z-index: 1000;\n      box-shadow: 4px 0 12px rgba(0, 0, 0, 0.3);\n    }\n  \n    .mobileNav.open {\n      transform: translateX(0);\n    }\n  \n    .mobileNav.open .navMenu {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 20px;\n    }\n  \n    .navLink {\n      display: block;\n      padding: 12px 0;\n      font-size: 18px;\n      color: #ffffff;\n      border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    }\n  \n    .navLink:last-child {\n      border-bottom: none;\n    }\n  }\n  \n  /* Add overlay background when menu is open */\n  .overlay {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 999;\n  }\n  \n  @media (max-width: 900px) {\n    .overlay.open {\n      display: block;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `dappNav_navbar__uwBFL`,
	"navContainer": `dappNav_navContainer__oFsNn`,
	"navLeft": `dappNav_navLeft__7+HuK`,
	"logo": `dappNav_logo__tIcDq`,
	"navRight": `dappNav_navRight__xSZi0`,
	"navMenu": `dappNav_navMenu__Ri3SY`,
	"navLink": `dappNav_navLink__K41jH`,
	"hamburger": `dappNav_hamburger__VqtKc`,
	"mobileNav": `dappNav_mobileNav__R1S84`,
	"open": `dappNav_open__-8Q5k`,
	"overlay": `dappNav_overlay__yV+CY`
};
export default ___CSS_LOADER_EXPORT___;
